/* Catalogue filters: all the cards are in the DOM, the pills just hide the rest.
   Fires one GA4 event per filter choice so we learn which groups people shop by. */
(function () {
  function init() {
    document.querySelectorAll('.dx-cat .dx-pills').forEach(function (bar) {
      if (bar.dataset.dxBound) return;
      bar.dataset.dxBound = '1';
      var section = bar.closest('.dx-cat') || document;
      var grid = section.querySelector('.dx-grid');
      var cards = section.querySelectorAll('.dx-grid .dx-card');
      var empty = section.querySelector('.dx-empty');
      var allPer = parseInt(grid && grid.dataset.allPer, 10) || 2;
      var lastSent = '';
      var more = section.querySelector('.dx-catlink a');
      var moreT = more && more.querySelector('.dx-catlink-t');

      function apply(key, label) {
        // "All items" is a sampler of each group; a pill shows that group in full
        var shown = 0, perCat = {};
        cards.forEach(function (c) {
          var on;
          if (key === 'all') {
            perCat[c.dataset.cat] = (perCat[c.dataset.cat] || 0) + 1;
            on = perCat[c.dataset.cat] <= allPer;
          } else {
            on = c.dataset.cat === key;
          }
          c.hidden = !on;
          if (on) shown++;
        });
        bar.querySelectorAll('.dx-pill').forEach(function (b) {
          var on = b.dataset.f === key;
          b.classList.toggle('dx-pill--on', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        if (empty) empty.hidden = shown > 0;
        // the link under the board follows the pill, so a group's full list is one tap away
        if (more) {
          var pill = key === 'all' ? null : bar.querySelector('.dx-pill[data-f="' + key + '"]');
          more.href = (pill && pill.dataset.url) || more.dataset.url;
          if (moreT) moreT.textContent = (pill && pill.dataset.more) || more.dataset.more;
        }
        if (label && label !== lastSent && typeof window.dxTrack === 'function') {
          lastSent = label;
          window.dxTrack('catalogue_filter', { filter: label });
        }
      }

      bar.addEventListener('click', function (e) {
        var btn = e.target.closest('.dx-pill');
        if (btn) apply(btn.dataset.f, btn.textContent.trim());
      });
      var reset = empty && empty.querySelector('.dx-empty-reset');
      if (reset) reset.addEventListener('click', function () { apply('all'); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
